/**
* 头部菜单
*/ 
<template>
  <el-menu class="navcon-header" router :default-active="this.$route.path" mode="horizontal" text-color="#333" active-text-color="#343951">
    <!-- <el-button class="buttonimg">
      <svg t="1649943597699" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2937" width="25" height="25">
        <path d="M896 232.727273h-744.727273a34.909091 34.909091 0 0 1 0-69.818182h744.727273a34.909091 34.909091 0 0 1 0 69.818182zM896 884.363636h-744.727273a34.909091 34.909091 0 0 1 0-69.818181h744.727273a34.909091 34.909091 0 0 1 0 69.818181zM709.818182 558.545455h-558.545455a34.909091 34.909091 0 0 1 0-69.818182h558.545455a34.909091 34.909091 0 0 1 0 69.818182z" p-id="2938" fill="#515151"></path>
      </svg>
    </el-button> -->
    <img class="logoimg" style="margin-left: 30px" src="../assets/img/logo.png" alt="">
    
    <!-- <img class="logoimg" style="height: 40px;" src="../assets/img/xiaoxiangyun-logo.png" alt=""> -->
    <el-divider direction="vertical" class="divider-border"></el-divider>
    <span class="consoleboard" @click="goTo('/dashboard')">
      控制台
    </span>
    <!-- <span class="productmenu">产品与服务</span> -->
    <!-- <el-input size="mini" class="inputmenu" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input2">
    </el-input> -->
    <!-- 个人中心 -->
    <el-submenu index="1" class="submenu">

      <template slot="title">
        <el-avatar :src="user.avatar?user.avatar:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" size="small" fit="fill"></el-avatar>
        <span class="username">{{$store.state.user.nickname}}</span>
      </template>
      <el-menu-item :index="1-1" @click="goTo('/personal/user')">
        <svg t="1649408076265" class="icon menuicon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5041" width="16" height="16">
          <path d="M614.348405 565.418992H409.567603A343.199825 343.199825 0 0 0 64 905.675093v20.222104C64 1024 216.305721 1024 409.567603 1024h204.780802c185.582602 0 345.567603 0 345.567603-98.102803v-20.15811a343.263819 343.263819 0 0 0-345.567603-340.256101z m-112.629441-25.981564a269.734712 269.734712 0 1 0-273.894323-269.670719 271.526544 271.526544 0 0 0 273.894323 269.670719z m0 0" p-id="5042" fill="#dbdbdb"></path>
        </svg>
        账号信息
      </el-menu-item>
      <el-menu-item index="1-2" style="display:none">
        <svg t="1649408032389" class="icon menuicon" viewBox="0 0 1169 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4011" width="18" height="18">
          <path d="M72.227662 0h996.553234c17.168557 1.082587 33.980498 7.794627 46.780497 19.359204 16.162388 14.239204 25.7401 35.547065 25.6 57.084179 0.012736 167.915622 0.025473 335.831244 0 503.734129-25.803781-31.751642-58.192239-58.141294-94.605373-76.812736-37.686766-19.435622-79.627463-30.47801-121.988458-32.261094-49.620697-2.228856-99.776318 8.227662-144.238806 30.401592-37.393831 18.531343-70.737512 45.11204-97.216318 77.360398-29.497313 35.827264-50.384876 78.697711-60.255523 124.039005-14.277413 64.751443-6.075224 134.240796 23.294727 193.719403-189.911244 0.025473-379.809751 0.012736-569.708259 0.012736-21.549851 0.127363-42.883184-9.450348-57.096915-25.625473C7.8201 858.249552 1.146269 841.501294 0 824.409154V72.40597C1.120796 54.345871 8.54607 36.680597 21.167761 23.638607 34.38806 9.628657 53.046766 1.235423 72.227662 0m240.487164 132.190249c-28.64398 3.362388-56.07801 16.162388-77.054726 35.954627-22.530547 20.96398-37.623085 49.735323-41.927961 80.213333-4.444975 30.274229 1.630249 61.974925 17.104876 88.39005 16.862886 29.153433 44.857313 51.671244 77.029254 61.707462 31.369552 9.99801 66.330746 8.138507 96.41393-5.22189 30.121393-13.169353 55.071841-37.635821 68.890746-67.451542 14.442985-30.681791 16.71005-66.827463 6.393632-99.126767-9.488557-30.363383-30.108657-56.995025-56.918607-74.061691-26.415124-16.926567-58.790846-24.275423-89.931144-20.403582m333.475025 31.471443c-6.457313 2.088756-11.984876 6.852139-14.965174 12.940099-3.960995 7.845572-3.413333 17.741692 1.426467 25.077811 4.63602 7.374328 13.271244 11.895721 21.97015 11.679204 109.978109 0.025473 219.968955 0.025473 329.947064 0.012736 8.698905 0.216517 17.346866-4.304876 22.021095-11.666467 5.196418-7.883781 5.412935-18.684179 0.522189-26.771742-4.534129-7.832836-13.475025-12.774527-22.517811-12.507064-107.851144 0.012736-215.689552 0-323.52796 0-4.9799 0.038209-10.0999-0.38209-14.87602 1.235423m0.063681 110.793233c-6.775721 2.152438-12.545274 7.29791-15.436418 13.80617-3.642587 7.947463-2.763781 17.754428 2.279801 24.899502 4.725174 6.966766 13.080199 11.195224 21.498906 11.004179 110.436617 0 220.873234 0.076418 331.309851-0.038209 14.035423 0.012736 26.134925-13.334925 24.670248-27.319403-0.598607-9.832438-7.501692-18.837015-16.773731-22.084776-5.005373-1.897711-10.443781-1.464677-15.678408-1.490149H661.027662c-4.941692 0.038209-10.010746-0.38209-14.77413 1.222686M214.199403 476.605771c-30.516219 23.460299-53.925572 55.976119-66.636418 92.3001-12.507065 35.648955-14.557612 74.851343-6.024279 111.63383 130.101493 0.025473 260.190249-0.025473 390.291742 0.025473 9.552239-40.794428 5.896915-84.581891-10.418309-123.172935-16.95204-40.450547-47.646567-74.940498-85.804577-96.515821-32.286567-18.505871-69.858706-27.53592-107.010547-25.931144-41.252935 1.464677-81.843582 16.315224-114.397612 41.660497z" p-id="4012" fill="#dbdbdb"></path>
          <path d="M882.028259 511.694328c50.066468-5.84597 101.788657 3.247761 146.658706 26.300498 39.75005 20.3399 74.061692 51.2 98.413533 88.619303 21.231443 32.464876 34.922985 69.795025 39.60995 108.296916 5.514826 44.296915-0.611343 90.045771-17.970946 131.196816-21.129552 50.512239-58.943682 93.85393-106.144477 121.63184-32.65592 19.410149-69.74408 31.433234-107.609154 34.668259-44.742687 4.126567-90.542488-3.782687-131.273234-22.772537-37.228259-17.346866-70.202587-43.711045-95.254926-76.277811-27.29393-35.317811-45.137512-77.882587-50.983482-122.141294-6.355423-47.022488 0.458507-95.789851 19.906866-139.093333 18.505871-41.58408 48.359801-77.971741 85.384278-104.399602 35.012139-25.090547 76.456119-41.125572 119.262886-46.029055m144.633632 157.051543c-5.056318 1.69393-8.877214 5.553035-12.481592 9.297512-41.813333 41.813333-83.61393 83.626667-125.44 125.414527-26.020299-25.994826-52.027861-52.015124-78.035423-78.022686-3.222289-3.209552-6.317214-6.724776-10.469254-8.737115-7.705473-3.973731-17.512438-3.324179-24.606567 1.642986-5.553035 4.024677-10.341891 9.666866-11.704677 16.557213-1.872239 8.100299 0.904279 16.977512 6.915821 22.708856 33.52199 33.509254 67.018507 67.056716 100.578706 100.540498 6.406368 6.457313 16.56995 8.660697 25.103284 5.553035 6.266269-2.037811 10.405572-7.412537 15.385473-11.386269 47.009751-46.882388 93.904876-93.904876 140.889154-140.812736 3.515224-3.375124 6.32995-7.578109 7.463483-12.366966 5.234627-18.467662-15.652935-37.686766-33.598408-30.388855z" p-id="4013" fill="#dbdbdb"></path>
        </svg>
        实名认证</el-menu-item>
      <el-menu-item index="1-3" style="display:none">
        <svg t="1649407777288" class="icon menuicon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3173" width="20" height="20">
          <path d="M179.2 182.4c-34.4 16.8-51.2 35.2-51.2 55.2v55.2c0 20 16.8 38.4 51.2 55.2 34.4 16.8 80.8 30.4 140 40 59.2 9.6 123.2 14.4 192.8 14.4s133.6-4.8 192.8-14.4c59.2-9.6 105.6-23.2 140-40 34.4-16.8 51.2-35.2 51.2-55.2v-55.2c0-20-16.8-38.4-51.2-55.2-34.4-16.8-80.8-30.4-140-40C645.6 132.8 581.6 128 512 128s-133.6 4.8-192.8 14.4c-58.4 10.4-105.6 23.2-140 40M128 552v69.6c0 20 16.8 38.4 51.2 55.2s80.8 30.4 140 40c59.2 9.6 123.2 14.4 192.8 14.4s133.6-4.8 192.8-14.4c59.2-9.6 105.6-23.2 140-40 34.4-16.8 51.2-35.2 51.2-55.2v-72.8c-40 24-93.6 42.4-162.4 54.4-68.8 12.8-142.4 18.4-221.6 18.4s-152.8-5.6-221.6-18.4C221.6 591.2 168 572.8 128 548.8M128 712v74.4c0 20 16.8 38.4 51.2 55.2s80.8 30.4 140 40c59.2 9.6 123.2 14.4 192.8 14.4s133.6-4.8 192.8-14.4c59.2-9.6 105.6-23.2 140-40 34.4-16.8 51.2-35.2 51.2-55.2v-72.8c-40 24-93.6 42.4-162.4 54.4-68.8 12-142.4 18.4-221.6 18.4s-152.8-6.4-221.6-18.4C221.6 756 168 737.6 128 713.6M128 384v72.8c0 20 16.8 38.4 51.2 55.2s80.8 30.4 140 40c59.2 9.6 123.2 14.4 192.8 14.4s133.6-4.8 192.8-14.4c59.2-9.6 105.6-23.2 140-40 34.4-16.8 51.2-35.2 51.2-55.2V384c-40 24-93.6 42.4-162.4 54.4-68.8 12-142.4 18.4-221.6 18.4s-152.8-6.4-221.6-18.4C221.6 426.4 168 408 128 384" p-id="3174" fill="#e6e6e6"></path>
        </svg>
        会员积分
      </el-menu-item>
      <el-divider class="menudivider"></el-divider>
      <el-menu-item @click="exit()" index="1-4"> <span class="exittxt">退出</span> </el-menu-item>
    </el-submenu>
    <!-- 从右到左第一个菜单 -->
    <el-menu-item index="2" class="submenu"  style="display:none">
      <i class="el-icon-message-solid"></i>
    </el-menu-item>
    <el-submenu index="3" class="submenu"  style="display:none">
      <template slot="title">工单</template>
      <el-menu-item index="/workorder/Orderlist">我的工单</el-menu-item>
      <el-menu-item index="3-1">提交工单</el-menu-item>
    </el-submenu>
    <el-menu-item index="/ai/article" class="submenu" v-if="user.balance">
      <svg t="1686560172452" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5422" width="18" height="18"><path d="M661.6 351.4c-40.6 0-85.2-5.5-131.2-18-55.4-15-112.1-39.3-164.2-69-0.8-0.3-1.5-0.8-2.1-1.2-81.1-46.5-150.8-105.9-186.1-163-4.3-7-2.2-16.2 4.8-20.5 7-4.4 16.2-2.2 20.5 4.8 30.7 49.7 89.6 101.3 159.3 143.6 7.2-30.3 21.5-90.4 32-138.9 1.2-5.3 5.1-9.6 10.3-11.1 68.4-20.3 141.9-16.9 238.5 10.8C778.1 127.5 861.7 219.1 846.6 275c-12 44-86.5 76.4-185 76.4z m-272-107.8c47.4 26 98.5 47.4 148.6 61 143.2 38.8 268.3 4.1 279.6-37.4 8.4-31-56.2-113.4-182.6-149.7-86.7-24.9-153-29.1-213.3-13.2-11.5 52.3-26.4 114.6-32.3 139.3z" fill="#707070" p-id="5423"></path><path d="M278.7 929c-1.5 0-3-0.2-4.5-0.7-5.6-1.8-9.7-6.7-10.4-12.6-0.3-3-33.4-302.9-88.1-821.9-0.9-8.2 5.1-15.5 13.3-16.4 8.2-0.8 15.5 5.1 16.4 13.3 44.2 419.6 74.3 696 84.4 788 211.6-241.8 510.3-584.6 522.1-601.6 4-7.2 12.8-9.5 20-5.5 7.2 3.9 9.7 13.4 5.7 20.7-7.8 14.4-421.2 487.1-547.7 631.6-2.8 3.3-7 5.1-11.2 5.1z" fill="#707070" p-id="5424"></path><path d="M436.9 959c-53.2 0-106.3-8.9-156.6-26.7l-19-6.7c-11.7-4.1-17.8-16.9-13.6-28.6 4.1-11.7 16.9-17.8 28.6-13.6l19 6.7c85.9 30.4 181.1 32.2 268.1 5l38.5-12c11.8-3.7 24.3 2.9 28 14.7 3.7 11.8-2.9 24.3-14.7 28l-38.5 12c-45.3 14.1-92.5 21.2-139.8 21.2z" fill="#707070" p-id="5425"></path><path d="M270.1 927l-31.4-288.8s66.1 62.9 120.2 70.6c54.1 7.6 108.3 5.6 108.3 5.6L270.1 927zM312.2 576c-3.2 0-6.5-1.1-9.1-3.1L228 515c-3.2-2.4-5.2-6-5.7-10l-23.8-196.2c-0.7-5.7 2-11.3 6.8-14.4 4.9-3.1 11.1-3.1 16 0l133.8 84.8c5.2 3.3 7.9 9.5 6.6 15.6l-35 169.3c-1 5-4.6 9.2-9.4 11-1.6 0.6-3.4 0.9-5.1 0.9z m-61.1-80.8l51.2 39.5 28.1-135.8-98.5-62.4 19.2 158.7zM645.4 510.7c-0.3 0-0.7 0-1-0.1-0.6-0.1-58.7-8.2-123.1-26.1-64.9-18-137.8-60.2-140.9-62-3.6-2.1-4.8-6.6-2.7-10.2 2.1-3.6 6.6-4.8 10.2-2.7 0.7 0.4 74.4 43 137.4 60.5 63.5 17.6 120.6 25.6 121.2 25.7 4.1 0.6 6.9 4.3 6.4 8.4-0.7 3.8-3.8 6.5-7.5 6.5zM412.3 543.9c-1 0-2.1-0.2-3.1-0.7-23.8-11-39.7-19.9-40.4-20.3-3.6-2-4.9-6.6-2.9-10.2 2-3.6 6.5-4.9 10.1-2.9 0.2 0.1 16.2 9 39.4 19.8 3.7 1.7 5.4 6.2 3.6 9.9-1.2 2.8-3.9 4.4-6.7 4.4zM539.6 577.4c-4 0-7.3-3.2-7.4-7.2-0.1-4.1 3.1-7.6 7.2-7.7 24.5-0.8 42.6-5.2 42.8-5.2 4-1 8 1.5 9 5.5s-1.5 8-5.5 9c-0.8 0.2-19.7 4.8-45.9 5.7 0-0.1-0.1-0.1-0.2-0.1z" fill="#707070" p-id="5426"></path></svg>
      智能写作
    </el-menu-item>
    <el-menu-item index="/apply" class="submenu">
      <svg t="1684734395782" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7251" width="18" height="18"><path d="M665.007158 433.340632a53.894737 53.894737 0 0 0-76.234105-76.207158l-85.746527 85.746526-85.746526-85.746526a53.894737 53.894737 0 0 0-76.207158 76.207158l161.953684 161.953684 161.953685-161.953684z m-161.953684-104.798316l28.56421-28.564211a134.736842 134.736842 0 1 1 190.544842 190.517895l-219.136 219.162947-219.109052-219.136a134.736842 134.736842 0 0 1 190.517894-190.544842l28.591158 28.564211zM161.684211 164.217263v380.685474a242.526316 242.526316 0 0 0 105.903157 200.380631l218.893474 149.234527 236.975158-151.444211A242.526316 242.526316 0 0 0 835.368421 538.677895V164.944842l-349.884632-56.050526L161.684211 164.217263z m-80.842106-68.176842L485.052632 26.947368l431.157894 69.093053V538.677895a323.368421 323.368421 0 0 1-149.234526 272.491789L485.052632 991.366737l-263.006316-179.280842A323.368421 323.368421 0 0 1 80.842105 544.902737V96.040421z" fill="#8a8a8a" p-id="7252"></path></svg>
      我的申请
    </el-menu-item>
    <el-menu-item index="/orders" class="submenu">
      <svg t="1673413988376" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6109" width="18" height="18"><path d="M387.543454 210.229049c17.253966 0 31.234375-13.980409 31.234375-31.234375L418.777829 164.601872l187.403181 0 0 14.393825c0 17.253966 13.980409 31.234375 31.234375 31.234375s31.233352-13.980409 31.233352-31.234375L668.648736 95.704712c0-17.253966-13.980409-31.233352-31.233352-31.233352s-31.234375 13.980409-31.234375 31.233352l0 6.42841L418.777829 102.133122l0-6.42841c0-17.253966-13.980409-31.233352-31.234375-31.233352-17.253966 0-31.233352 13.980409-31.233352 31.233352l0 83.289961C356.310102 196.248639 370.290511 210.229049 387.543454 210.229049z" fill="#707070" p-id="6110"></path><path d="M401.005047 311.017546c-17.253966 0-31.234375 13.980409-31.234375 31.234375L369.770671 372.721887c0 17.253966 13.980409 31.234375 31.234375 31.234375s31.233352-13.980409 31.233352-31.234375l0-30.470989C432.239422 324.996932 418.259012 311.017546 401.005047 311.017546z" fill="#707070" p-id="6111"></path><path d="M623.952768 311.017546c-17.253966 0-31.233352 13.980409-31.233352 31.234375L592.719416 372.721887c0 17.253966 13.980409 31.234375 31.233352 31.234375s31.234375-13.980409 31.234375-31.234375l0-30.470989C655.187143 324.996932 641.206734 311.017546 623.952768 311.017546z" fill="#707070" p-id="6112"></path><path d="M546.344203 461.228663c-0.132006 0.193405-13.614066 19.754926-34.172287 19.754926-19.989263 0-32.423457-18.098193-33.267685-19.36914-9.17087-14.427594-28.254507-18.809391-42.834574-9.770528-14.650675 9.109472-19.155269 28.367071-10.055007 43.017746 11.214413 18.047028 41.970904 48.589648 86.157265 48.589648 43.963281 0 75.105558-30.318516 86.574774-48.223305 9.222035-14.396895 5.03262-33.358759-9.242502-42.763966C575.199391 443.070094 555.912116 447.065082 546.344203 461.228663z" fill="#707070" p-id="6113"></path><path d="M758.781546 102.100376c-17.253966 0-31.234375 13.980409-31.234375 31.233352s13.980409 31.233352 31.234375 31.233352c41.827641 0 75.857688 34.864042 75.857688 77.708849l0 577.389266c0 42.844807-34.030048 77.708849-75.857688 77.708849l-492.614487-0.061398c-41.818431 0-75.847455-34.864042-75.847455-77.708849L190.319603 242.215554c0-42.844807 34.030048-77.708849 75.847455-77.708849 17.253966 0 31.233352-13.980409 31.233352-31.233352s-13.980409-31.233352-31.233352-31.233352c-76.264964 0-138.315182 62.884213-138.315182 140.176576l0 577.389266c0 77.29134 62.051241 140.176576 138.315182 140.176576l492.614487 0.061398c76.275197 0 138.325415-62.884213 138.325415-140.176576L897.106961 242.275929C897.106961 164.984588 835.056744 102.100376 758.781546 102.100376z" fill="#707070" p-id="6114"></path><path d="M252.196883 793.260825c0 17.253966 13.980409 31.234375 31.233352 31.234375l458.096323 0c17.253966 0 31.233352-13.980409 31.233352-31.234375s-13.980409-31.233352-31.233352-31.233352L283.431258 762.027473C266.177292 762.027473 252.196883 776.006859 252.196883 793.260825z" fill="#707070" p-id="6115"></path></svg>
      订单
    </el-menu-item>
    <el-menu-item index="/product" class="submenu">
      <svg t="1673413686298" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2722" width="18" height="18"><path d="M504.1 452.5c-18.3 0-36.5-4.1-50.7-10.1l-280.1-138c-18.3-10.1-30.4-24.4-30.4-40.6 0-16.2 10.2-32.5 30.4-42.6L455.4 77.1c16.2-8.1 34.5-12.2 54.8-12.2 18.3 0 36.5 4.1 50.7 10.1L841 213c18.3 10.1 30.4 24.4 30.4 40.6 0 16.2-10.1 32.5-30.4 42.6L558.9 440.3c-16.3 8.1-34.5 12.2-54.8 12.2zM193.6 261.7l280.1 138c8.1 4.1 18.3 6.1 30.4 6.1 12.2 0 24.4-2 32.5-6.1l284.1-144.1-280.1-138c-8.1-4.1-18.3-6.1-30.4-6.1-12.2 0-24.4 2-32.5 6.1L193.6 261.7z m253.6 696.1c-10.1 0-20.3-2-30.4-8.1L165.1 817.8c-30.4-14.2-52.8-46.7-52.8-73.1V391.6c0-24.4 18.3-42.6 44.6-42.6 10.1 0 20.3 2 30.4 8.1L437.1 489c30.4 14.2 52.8 46.7 52.8 73.1v353.1c0 24.4-18.3 42.6-42.7 42.6z m-10.1-48.7c2 2 4.1 2 6.1 2v-349c0-8.1-10.1-24.4-26.4-32.5L165.1 397.7c-2-2-4.1-2-6.1-2v349.1c0 8.1 10.2 24.4 26.4 32.5l251.7 131.8z m144.1 48.7c-24.4 0-42.6-18.3-42.6-42.6V562.1c0-26.4 22.3-58.9 52.8-73.1L841 357.1c10.1-4.1 20.3-8.1 30.4-8.1 24.4 0 42.6 18.3 42.6 42.6v353.1c0 26.4-22.3 58.9-52.8 73.1L611.6 949.7c-12.2 6.1-20.3 8.1-30.4 8.1z m280-560.1L611.6 529.6c-16.2 8.1-26.4 24.4-26.4 32.5v349.1c2 0 4.1-2 6.1-2l249.6-131.9c16.2-8.1 26.4-24.4 26.4-32.5V395.7c-2 0-4 2-6.1 2z m0 0" p-id="2723" fill="#707070"></path></svg>
      我的服务
    </el-menu-item>
    <!-- <el-submenu index="4" class="submenu">
      <template slot="title">费用</template>
      <el-menu-item index="/orders">订单</el-menu-item>
      <el-menu-item index="/product">我的产品</el-menu-item>
    </el-submenu> -->
    <!-- <el-submenu index="5" class="submenu">
      <template slot="title">帮助</template>
    </el-submenu> -->
    
    <el-menu-item index="/dashboard" class="submenu">
      <svg t="1673413890197" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4788" width="18" height="18"><path d="M131.667968 514.582528c-7.747584 7.7312-20.905984 7.7312-28.64128 0-7.745536-7.759872-7.745536-20.905984 0-29.44L497.010688 91.174912c8.51968-7.735296 21.661696-7.735296 29.425664 0l393.965568 393.967616c8.505344 8.534016 8.505344 21.680128 0 29.44-7.733248 7.7312-20.905984 7.7312-28.637184 0L511.715328 134.53312 131.667968 514.582528z" p-id="4789" fill="#707070"></path><path d="M810.483712 434.049024c0-11.573248 8.534016-20.105216 20.13184-20.105216 11.599872 0 20.905984 8.534016 20.905984 20.105216L851.521536 924.81536c0 10.825728-9.306112 20.105216-20.905984 20.105216L192.813056 944.920576c-10.840064 0-20.119552-9.279488-20.119552-20.105216L172.693504 434.049024c0-11.573248 9.279488-20.105216 20.119552-20.105216 11.61216 0 20.893696 8.534016 20.893696 20.105216l0 469.860352 596.779008 0L810.48576 434.049024z" p-id="4790" fill="#707070"></path></svg>
      主页
    </el-menu-item>
  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
//实体类
import { User} from '../module/entity' 

export default {
  name: 'navcon',
  props: {
    // leftMenuShow,
    user:{
      type: Object,
      default: new User()
    }
  },
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      input2: ''
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    // 退出登录
    exit() {
      if(localStorage.getItem('logintoken')){
        loginout().then(res => {
          if (res.status==="0000_0") {
            //如果请求成功就让他2秒跳转路由
            setTimeout(() => {
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
              this.$message({
                type: 'success',
                message: '已退出登录!'
              })
            }, 1000)
          } else {
            this.$message.error(res.messages)
            return false
          }
        })
        .catch(err => {
          this.logining = false
          this.$message.error('退出失败，请稍后再试！')
        })
      }else{
        this.$store.commit('logout', 'false')
        this.$router.push({ path: '/login' })
      }
      
      
    },
    goTo(url){
        this.$router.push(url)
    },
  },
  watch:{
    $store(val){
      console.log(this.$store.state.nickname)
    }
  }
}
</script>
<style scoped>
.navcon-header {
  width: 100%;
  height: 50px;
  /* background-color: rgb(37, 42, 47); */
}
.navcon-header .el-menu-item.is-active {
    border-bottom: 2px solid #409EFF;
    color: #303133;
    border-bottom-color: #c92310 !important;
}
.divider-border{
  height: 1.5em;margin-left: 140px;position: absolute;top:14px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 50px;
  background-color: transparent;
  border: none;
  box-shadow: 1px 1px 10px #e9e9e9;
  border-radius: 0px;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}

.el-breadcrumb {
  float: left;
  margin-left: 70px;
  color: white;
  font-size: 14px;
  margin-top: 23px;
}
.el-breadcrumb__inner,
.is_link {
  color: white;
  font-weight: lighter;
}

.logoimg {
  height: 32px;
  position: absolute;
  top: 10px;
  /* left: 67px; */
  margin-left: 30px;
}
.logotxt {
  position: absolute;
  top: 17px;
  margin-left: 140px;
  font-weight: 700;
}
.username {
  margin-left: 3px;
}
.menuicon {
  padding-left: 10px;
  padding-right: 4px;
}
.menudivider {
  /* padding: 10px; */
  margin-top: 10px;
  margin-bottom: 10px;
}
.exittxt {
  padding-left: 20px;
}
.el-menu-item {
  padding-top: 0px;
}
.inputmenu {
  width: 200px;
  position: absolute;
  top: 12px;
  margin-left: 570px;
}
.consoleboard {
  position: absolute;
  top: 15px;
  margin-left: 160px;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.productmenu {
  position: absolute;
  top: 17px;
  margin-left: 270px;
  color: white;
  font-size: 14px;
}
.el-icon-message-solid:hover {
  /* color: #343951; */
  color: #cb4a3f;
}
</style>

<style >
.el-submenu__title i {
  display: none;
}
.el-menu-item,
.el-submenu__title {
  height: 50px;
  line-height: 50px;
}
.el-submenu__title:hover {
  font-weight: bold;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}
.el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
}
.inputmenu .el-input__inner {
  border-radius: 3px;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #fff;
  border-bottom-color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue